import reactComponentLoader from 'scripts/react-component-loader'

import Markdown from './index'

reactComponentLoader(
  Markdown,
  '[data-markdown-content]'
)
